import Navbars from '../Navbar';
import RegBody from '../RegBody';
export default function SignUp(){
    return <>
        <Navbars/>
        <RegBody/>
    </>
}